module.exports = __webpack_public_path__ + "img/346088_6ABED7_56A0C5_4E91B8-256px.0b671886.png";